const listeners = new Set<() => void>();

// Saving a risk score elsewhere (Investor Profile, account opening) tells the
// mounted risk-score readers, such as Home's avatar, to load again.
export const notifyRiskScoresChanged = () => {
  listeners.forEach((listener) => listener());
};

export const onRiskScoresChanged = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
